module.exports = __webpack_public_path__ + "img/list_member.cb3665db.png";